if (!customElements.get('liubai-gallery-arrows')) {
  customElements.define('liubai-gallery-arrows', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.gallery = this.closest('media-gallery');
      const mediaList = this.gallery.querySelector('[id^="Slider-Gallery-"]');
      const getSlides = () => [...mediaList.querySelectorAll(':scope > li[data-media-id]')].filter(slide => !slide.classList.contains('product__media-item--variant') || slide.classList.contains('is-active'));
      const getIndex = (slides) => {
        if (matchMedia('(max-width: 749px)').matches) {
          const left = mediaList.getBoundingClientRect().left;
          return slides.reduce((best, slide, i) => Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(slides[best].getBoundingClientRect().left - left) ? i : best, 0);
        }
        return Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
      };
      const syncCounter = () => {
        const slides = getSlides();
        if (!slides.length) return;
        const viewer = this.gallery.querySelector('[id^="GalleryViewer-"]');
        const current = viewer.querySelector('.slider-counter--current');
        const total = viewer.querySelector('.slider-counter--total');
        if (current) current.textContent = getIndex(slides) + 1;
        if (total) total.textContent = slides.length;
      };
      this.onMediaScroll = () => {
        cancelAnimationFrame(this.counterFrame);
        this.counterFrame = requestAnimationFrame(syncCounter);
      };
      mediaList.addEventListener('scroll', this.onMediaScroll, { passive: true });
      this.mediaObserver = new MutationObserver(this.onMediaScroll);
      this.mediaObserver.observe(mediaList, { subtree: true, attributes: true, attributeFilter: ['class'], childList: true });
      this.resizeObserver = new ResizeObserver(() => {
        this.style.height = `${mediaList.offsetHeight}px`;
        this.onMediaScroll();
      });
      this.resizeObserver.observe(mediaList);
      const header = document.querySelector('.header__heading-link, .header__menu-item');
      if (header) this.style.setProperty('--liubai-gallery-arrow-color', getComputedStyle(header).color);
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-direction]');
        if (!button || typeof this.gallery.setActiveMedia !== 'function') return;
        const slides = getSlides();
        if (slides.length < 2) return;
        const index = getIndex(slides);
        const next = (Math.max(0, index) + Number(button.dataset.direction) + slides.length) % slides.length;
        this.gallery.setActiveMedia(slides[next].dataset.mediaId, false);
      });
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.mediaObserver?.disconnect();
      cancelAnimationFrame(this.counterFrame);
      this.gallery?.querySelector('[id^="Slider-Gallery-"]')?.removeEventListener('scroll', this.onMediaScroll);
    }
  });
}
